export const  Lawyers = [
  {
    name: "Adv. Kea",
    email: "Keabetswe@inclusivitysolutions.com",
    phoneNumber: "25411222333"
  },
   {
    name: "Adv Newton",
    email: "murrithinewton700@gmail.com",
    phoneNumber: "254745600004"
  },
  {
    name: "Adv. Enock",
    email: "Enock@inclusivitysolutions.com",
    phoneNumber: "254712345678"
  },
  {
    name: "Adv. Otieno",
    email: "murrithinewton700@gmail.com",
    phoneNumber: "254798112233"
  },
  {
    name: "Adv. Mateli",
    email: "murrithinewton700@gmail.com",
    phoneNumber: "254798112233"
  }
];
